var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarIcon1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66406 1.33252V14.657L3.99651 13.9908L5.32896 14.657L6.66141 13.9908L7.99386 14.657L9.32631 13.9908L10.6588 14.657L11.9912 13.9908L13.3237 14.657V1.33252L11.9912 1.99874L10.6588 1.33252L9.32631 1.99874L7.99386 1.33252L6.66141 1.99874L5.32896 1.33252L3.99651 1.99874L2.66406 1.33252Z",
    stroke: "#90A1B9",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6579 5.32959H6.66058C6.30719 5.32959 5.96827 5.46997 5.71839 5.71986C5.46851 5.96974 5.32813 6.30865 5.32812 6.66204C5.32813 7.01543 5.46851 7.35434 5.71839 7.60422C5.96827 7.85411 6.30719 7.99449 6.66058 7.99449H9.32548C9.67886 7.99449 10.0178 8.13487 10.2677 8.38476C10.5175 8.63464 10.6579 8.97355 10.6579 9.32694C10.6579 9.68033 10.5175 10.0192 10.2677 10.2691C10.0178 10.519 9.67886 10.6594 9.32548 10.6594H5.32812",
    stroke: "#90A1B9",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99609 11.659V4.33057",
    stroke: "#90A1B9",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon1);
export default __webpack_public_path__ + "static/media/dollarIcon1.542df2892c1dddb1b975d1c723f5f0f1.svg";
export { ForwardRef as ReactComponent };